import { type ButtonHandle, createButton } from '../primitives/button';
import { type ModalHandle, createModal } from '../primitives/modal';

export interface PauseOverlayOptions {
  onResume: () => void;
  onRestart: () => void;
  onSettings?: () => void;
  onQuit?: () => void;
  title?: string;
}

export interface PauseOverlayHandle {
  readonly el: HTMLElement;
  show(): void;
  hide(): void;
  destroy(): void;
}

export function createPauseOverlay(opts: PauseOverlayOptions): PauseOverlayHandle {
  const body = document.createElement('div');
  body.className = 'fg-pause__body';

  const actions: ButtonHandle[] = [
    createButton({
      variant: 'primary',
      label: 'RESUME',
      onClick: () => {
        modal.hide();
        opts.onResume();
      },
    }),
    createButton({
      variant: 'secondary',
      label: 'RESTART',
      onClick: () => {
        modal.hide();
        opts.onRestart();
      },
    }),
  ];

  if (opts.onSettings) {
    actions.push(
      createButton({ variant: 'secondary', label: '⚙ SETTINGS', onClick: opts.onSettings }),
    );
  }
  if (opts.onQuit) {
    actions.push(
      createButton({
        variant: 'tertiary',
        label: 'Quit to menu',
        onClick: () => {
          modal.hide();
          opts.onQuit?.();
        },
      }),
    );
  }

  const modal: ModalHandle = createModal({
    title: opts.title ?? 'PAUSED',
    body,
    actions,
    onDismiss: () => opts.onResume(), // Esc / backdrop = resume
  });

  return {
    el: modal.el,
    show: () => modal.show(),
    hide: () => modal.hide(),
    destroy() {
      for (const b of actions) b.destroy();
      modal.destroy();
    },
  };
}
